import { useEffect } from 'react'; 
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import CreatePasswordPage from "./pages/CreatePasswordPage";
import ProfilePage from "./pages/ProfilePage";
import InterviewPage from "./pages/InterviewPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthProvider";
import { UserProvider } from "./contexts/UserContext";
import JobListingsPage from "./pages/JobListingsPage";
import { Toaster } from 'react-hot-toast';
import JobListingDetailsPage from "./pages/JobListingDetailsPage";
import JobListingsTab from "./components/JobListingsTab";
import InterviewsTab from './components/InterviewsTab';
import OrganizationTab from "./components/OrganizationTab";
import SettingsTab from "./components/SettingsTab";
import JobDetailsPage from "./pages/JobDetailsPage";
import PricingPage from "./pages/PricingPage";
import AboutUsSection from "./pages/AboutUsSection";
import SupportPage from "./pages/SupportPage";
import InboxPage from "./pages/InboxPage";
import ActivityPage from "./pages/ActivityPage";
import CreateJobWrapper from "./pages/CreateJobWrapper";
import { initMixpanel } from './utils/mixpanel';
import SmartProfilePage from "./pages/SmartProfilePage"
import ResumeAnalysisPage from "./pages/ResumeAnalysisPage";
import AiInterviewPage from './pages/AiInterviewPage';
import DemoAiInterviewPage from './pages/DemoAiInterviewPage';
import AddInterviewRoundStructure from './components/AddInterviewRoundStructure';
import CreateAiInterview from  './components/CreateAiInterview';
import AddRoundPanelPage from './components/AddRoundPanel';
import ReportPage from "./pages/ReportPage"
import PrivacyPolicy from './pages/PrivacyPolicy';
import DownloadInterviewGuardPage from './pages/DownloadInterviewGuardPage';
import FindJobRequestPage from './pages/FindJobRequestPage';
import OnboardOrgPage from './pages/OnboardPage';
import { UnreadProvider } from "./contexts/UnreadContext"
import AiCopilotDemoPage from './pages/AiCopilotDemoPage';
import ResolutHome from './pages/ResolutHome';

function App() {
  useEffect(() => {
    // Initialize Mixpanel when app loads
    initMixpanel();
  }, []);

  return (
    <Router>
      <AuthProvider>
        <UserProvider>
          <UnreadProvider>
          <Routes>
            <Route path="/" element={<ResolutHome />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/job-listings" element={<JobListingsPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/onboard" element={<OnboardOrgPage />} />
            <Route path="/register/create-password" element={<CreatePasswordPage />} />
            <Route path="/jobs" element={<JobListingsTab />} />
            <Route path="/jobs/create" element={
              <ProtectedRoute>
                <CreateJobWrapper />
              </ProtectedRoute>
            } />
            <Route path="/jobs/:jobId/edit" element={
              <ProtectedRoute>
                <CreateJobWrapper />
              </ProtectedRoute>
            } />

            <Route path="/job-finder" element={<FindJobRequestPage />} />
            <Route path="/interviews" element={<InterviewsTab />} />
            <Route path="/organisation" element={<OrganizationTab />} />
            <Route path="/settings" element={<SettingsTab />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/about-us" element={<AboutUsSection />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
             <Route path="/setup-interviewguard" element={<DownloadInterviewGuardPage />} />
            <Route path="/profile" element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            } />
            <Route path="/meeting/:meetingId" element={<InterviewPage />} />

            <Route path="/ai-interview/:id" element={<AiInterviewPage />} />

            <Route path="/jobs/:jobId" element={<JobDetailsPage />} />
            <Route
              path="/jobs/:orgId/:jobId"
              element={<JobListingDetailsPage />}
            />
            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" />} />

            <Route path="/inbox" element={<InboxPage />} />
            <Route path="/inbox/:conversationId" element={<InboxPage />} />
            <Route path="/activity" element={<ActivityPage />} />

            {/* Smart Profile Route */}
            <Route path="/profile/:userId" element={<SmartProfilePage />} />

            <Route path="/resume-analysis" element={<ResumeAnalysisPage />} />

            <Route path="/demo/ai-interview" element={<DemoAiInterviewPage />} />


            <Route path="/jobs/:orgId/:jobId/add-structure" element={<AddInterviewRoundStructure />} />

            <Route path="/jobs/:orgId/:jobId/add-ai-interview" element={<CreateAiInterview />} />

            <Route path="/jobs/:orgId/:jobId/add-structure-wrapper" element={<AddRoundPanelPage />} />

            <Route path="/reports/:reportId" element={<ReportPage />} />
              <Route path="/demo/ai-copilot" element={<AiCopilotDemoPage />} />
          </Routes>
          </UnreadProvider>
          <Toaster
            position="bottom-center"
            reverseOrder={false}
            gutter={8}
            containerClassName=""
            containerStyle={{}}
            toastOptions={{
              // Default options for all toasts
              className: '',
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
                fontSize: '14px',
                borderRadius: '8px',
                padding: '12px 16px',
              },

              // Specific options for different toast types
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#10B981',
                  secondary: '#fff',
                },
                style: {
                  background: '#10B981',
                  color: '#fff',
                },
              },

              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#EF4444',
                  secondary: '#fff',
                },
                style: {
                  background: '#EF4444',
                  color: '#fff',
                },
              },

              loading: {
                iconTheme: {
                  primary: '#3B82F6',
                  secondary: '#fff',
                },
                style: {
                  background: '#3B82F6',
                  color: '#fff',
                },
              },
            }}
          />
        </UserProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;